module.exports = __webpack_public_path__ + "img/局放系统运行总览.99bdbd85.png";